import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { FaCheckCircle } from 'react-icons/fa';

const SuccessModal = ({ show, handleClose, successMessage, onAfterClose }) => {
  const handleButtonClick = () => {
    handleClose();

    if (onAfterClose) {
      onAfterClose();
    }
    
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      backdrop="static"
      keyboard={false}
    >
      <Modal.Body className="text-center">
        <FaCheckCircle size={100} color="green" className="mb-3" />
        <h5>{successMessage}</h5>
        <Button 
          variant="success" 
          onClick={handleButtonClick} 
          className="mt-3"
        >
          Fechar
        </Button>
      </Modal.Body>
    </Modal>
  );
};

export default SuccessModal;